import { atom } from 'jotai';
import { BaseinfoRes } from '@/types/api/hall/baseinfo.d';

export enum TabTitle {
  Explore = 'Explore',
  Casino = 'Casino',
  Sports = 'Sports',
  Rummy = 'Rummy',
  Fantasy = 'Fantasy'
}

// 基础数据原子
export const baseInfoAtom = atom<BaseinfoRes | null>(null);

// 用户信息原子
export const userInfoAtom = atom(
  (get) => get(baseInfoAtom)?.user_info || null
);


// 导航标签原子
export const navTabsAtom = atom(
  (get) => get(baseInfoAtom)?.nav_tabs || []
);

// 设置base数据的原子
export const setBaseInfoAtom = atom(
  null,
  (_get, set, data: BaseinfoRes) => {
    // 组合localTabs和tabsData
    const tabsData = data?.nav_tabs;
    let combinedTabs: BaseinfoRes['nav_tabs'] = [];

    if (tabsData && tabsData.length > 0) {
      // 将API返回的tabs与本地tabs合并
      combinedTabs = tabsData.map(apiTab => {
        return {
          ...apiTab, // 使用API的数据（link等）
          link: apiTab.link.toLowerCase(),
        };
      });
    }

    //使用组合后的tabs
    const finalData = { ...data, nav_tabs: combinedTabs };
    set(baseInfoAtom, finalData);
  }
);

// base数据为loading的原子
export const baseInfoLoadingAtom = atom<boolean>(true);
// 设置base数据为loading的原子
export const setBaseInfoLoadingAtom = atom(
  null,
  (_get, set, data: boolean) => {
    set(baseInfoLoadingAtom, data);
  }
);

// 当前选中的 tab 原子（用于心跳埋点等场景）
export const currentTabAtom = atom<TabTitle | null>(null);
